import {Service} from '@s-ui/domain'

class GetUrlSearchService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {FromSearchJSONToUrlVOProxyMapper} deps.fromSearchJSONToUrlVOProxyMapper
   * @param {GetUrlService} deps.getUrlService
   * @param {SearchRequestValueObject} deps.searchRequestValueObject
   */
  constructor({config, fromSearchJSONToUrlVOProxyMapper, getUrlService, searchRequestValueObject}) {
    super({
      config,
      fromSearchJSONToUrlVOProxyMapper,
      getUrlService,
      searchRequestValueObject
    })

    this._config = config
    this._defaultSortOrder = this._config.get('ORDER').DESC
    this._defaultSortBy = this._config.get('SORT_FIELDS').RELEVANCE
    this._fromSearchJSONToUrlVOProxyMapper = fromSearchJSONToUrlVOProxyMapper
    this._getUrlService = getUrlService
    this._searchRequestValueObject = searchRequestValueObject
  }

  /**
   * @param {Object} params
   * @param {String} params.pagePlaceholder
   * @param {Object} params.search
   * @param {Number} params.search.page
   * @param {String} params.search.sortBy
   * @param {Number} params.search.sortOrder
   * @param {Number} params.search.categoryId
   * @param {Number} params.search.offerTypeId
   * @param {Object} params.search.filters,
   * @return {Promise<Object, Error>} search params object
   * @return {Object<url: String>}
   */

  async execute({dealerSlug, listingSectionId, pageName, path, queryPlaceholder, search = {}} = {}) {
    const {
      page = 1,
      sortBy = this._defaultSortBy,
      sortOrder = this._defaultSortOrder,
      categoryId,
      offerTypeId,
      ...filters
    } = search

    const searchRequestValueObject = this._searchRequestValueObject({
      page,
      sortBy,
      sortOrder,
      categoryId,
      offerTypeId,
      ...filters
    })

    const searchQuery = await this._fromSearchJSONToUrlVOProxyMapper
      .createFor({pageName})
      .setParams({...searchRequestValueObject.toJSON(), listingSectionId})
      .map()

    return this._getUrlService.execute({
      listingSectionId,
      path,
      pageName,
      params: {categoryId, offerTypeId, dealerSlug},
      query: {
        ...searchQuery,
        ...(queryPlaceholder && {
          [queryPlaceholder.query]: queryPlaceholder.placeholder
        })
      },
      search
    })
  }
}

export default GetUrlSearchService
